import { useState, useRef, useEffect } from 'react';
import TickImg from "../../Assets/Images/thankyou-tick-green.png";
import thankYou from '../../Assets/Images/thanks.gif'
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import Develop from '../../Assets/Images/develop-leader-logo.png'
import Align from '../../Assets/Images/align-teams-logo.png'
import Culture from '../../Assets/Images/healthy-culture-logo.png'

const Outro = () => {

  const { windowWidth } = useWindowDimensions();
  const location = useLocation()
  const [name, setName] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams();

  const [hasLeader, setHasLeader] = useState(false);
  const [leader, setLeader] = useState(null);
  const [member, setMember] = useState(null);
  const [selfUser, setSelfUser] = useState(null)

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`searchParams-${id}`)) || {};
    const searchParamLeaderName = searchParams.get('leader')
    const searchParamsRespondentName = searchParams.get('userName')
    const searchParamsSelfUserName = searchParams.get('selfUserName')

    console.log('searchParamsRespondentName', searchParamsRespondentName)
    console.log('searchParamsSelfUserName', searchParamsSelfUserName)

    if (searchParamLeaderName) {
      setLeader(searchParamLeaderName);
      setMember(storedData.member || null);
    }
    else if (searchParamsRespondentName) {
      setSelfUser(searchParamsRespondentName)
    }
    else {
      setLeader(storedData.leader || null);
      setMember(storedData.member || null);
      setSelfUser(storedData.userName || storedData.selfUserName)
    }

    // setHasLeader(!!storedData.leader);
  }, []);


  useEffect(() => {

    if (leader !== null && member !== null) {
      setHasLeader(true);
      setName(member);
    } else {
      setHasLeader(false);
    }
  }, [searchParams, member]);

  useEffect(() => {
    if (searchParams.get("name")) {
      setName(searchParams.get("name"));
    }

  }, [searchParams])

  useEffect(() => {
    // document.body.style.background = "linear-gradient(180deg, #172D43 0%, rgba(39, 80, 120, 0.9) 100%)";
    localStorage.removeItem("assessmentName");

    return () => {
      localStorage.removeItem("assessmentName");
      localStorage.removeItem("searchParams");
    }
  }, []);

  return (
    <>

      {/* {windowWidth > 830 && <p>Thank you for your time!</p>}
      <img src={thankYou} alt='thankyou' />
      <div className='checkout'>
        {windowWidth <= 830 && <p>Thank you for your time!</p>}
        Check us out <a href="https://sugarcreek.net/" title="https://sugarcreek.net" target="_blank" rel="noreferrer">here</a>
        <br />to know more about Sugar Creek.
      </div>
  */}

      <div className="outro thank-you">
        <div className="details-container">
          <div className="tick">
            <img src={TickImg} alt="" />
          </div>
          {/* <div className="tick">&#10003;</div> */}
          <h1 className='thank-you-header'>
            Thank you for taking the {windowWidth <= 830  && <br/> } 360 Assessment{leader ? ' for' : ","} <br />
            {(() => {
              const displayName = selfUser || leader;
              return displayName
              ?.split(' ')
              ?.map(word =>
                word === word.toUpperCase()
                  ? word
                  : word
                      ?.split('-')
                      ?.map(
                        part =>
                          part?.charAt(0)?.toUpperCase() + part?.slice(1)?.toLowerCase()
                      )
                      ?.join('-')
              )
              ?.join(' ');
            })()}!
          </h1>
          <p className='bottom-line mobile-view' >Your input is a valuable part of {leader ? ' their' : "your"} growth journey.</p>
          <div className="new-content">

          <p className='bottom-line last' >At Quadrant Flow, we support the growth of healthy,
            <div>high-performing leaders and teams.</div>
          </p>
          <p className='points'>
            <div className="points-section">
            <img src={Develop} alt="" /> <span className='point-name'>Develop Leaders</span> <br/>

            </div>
            <div className="points-section">
            <img src={Align} alt="" /> <span className='point-name'>Align Teams</span> <br/>
            </div>
            <div className="points-section">
            <img src={Culture} alt="" /> <span className='point-name'>Build Healthy Culture</span> <br/>
            </div>
            </p>
        </div>
          </div>
      </div>
    </>

  )
}

export default Outro;

